module.exports = __webpack_public_path__ + "img/updown.43b17c31.svg";